<template>
  <div class="app-header">
    <div class="app-info">
      <span
        v-if="app.status == false"
        class="app-status-badge inactive"
      >
        Inactive
      </span>
      <img :src="app.appIconUrl" :alt="app.appName" class="app-icon" />
      <div class="app-details">
        <h1 class="app-name" v-html="app.appName"></h1>
        <div class="app-meta">
          <span v-if="app.appRate" class="app-rate">{{ app.appRate }} ★</span>
          <span v-if="app.appReviewsCount" class="review-count"
            >({{ app.appReviewsCount }})</span
          >
          <div class="d-flex">
            <a :href="developer?.developerUrl" target="_blank" rel="noopener">
              <img
                :src="getStoreImage(platformType.id)"
                alt="Developer"
                class="platform-icon"
            /></a>
            <a
              v-if="developer.developerName"
              :href="
                $router.resolve({
                  name: 'Developer',
                  params: { storeId: developer.developerUrlId },
                }).href
              "
              class="developer-link"
            >
              {{ developer.developerName }}
            </a>
          </div>
          <a
            :href="app.appUrl"
            target="_blank"
            rel="noopener"
            class="platform-badge"
            :class="platformType.typeName.toLowerCase()"
          >
            <img
              :src="getStoreImage(platformType.id)"
              :alt="platformType"
              class="platform-icon"
            />
            {{ platformType.typeName }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeImage } from "@/ultis/user/functions/storePlatform";

export default {
  name: "AppHeader",
  props: {
    app: {
      type: Object,
      required: true,
    },
    developer: {
      type: Object,
      required: true,
    },
    platformType: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStoreImage(platformType) {
      return storeImage(platformType);
    },
    goToDeveloper() {
      this.$router.push({
        name: "Developer",
        params: { storeId: this.developer.developerUrlId },
      });
    },
  },
};
</script>

<style scoped>
.app-header {
  padding: 20px;
  background: white;
  border-bottom: 1px solid #eee;
  width: 100%;
  border-radius: 10px 10px 0px 0px;
  box-shadow: 0 0 5px #9e9e9e;
}

.app-info {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.app-icon {
  width: 80px;
  height: 80px;
  border-radius: 12px;
}

.app-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-name {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.app-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #666;
}

.app-rate {
  font-weight: 600;
  color: #333;
}

.review-count {
  color: #666;
}

.developer-link {
  color: var(--text-color);
  cursor: pointer;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.2s ease-in-out;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: 3px;
}

.developer-link:hover {
  text-decoration: underline;
}

.developer-icon {
  width: 16px;
  height: 16px;
}

.platform-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background: #eeeeee;
  color: #555;
}

.platform-badge img {
  width: 16px;
  height: 16px;
}

.platform-badge.play.store {
  background: #e8f5e9;
  color: #43a047;
}

.platform-badge.app.store {
  background: #1596f747;
  color: #1298fa;
}

.platform-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.app-status-badge {
  position: absolute;
  top: 0;
  right: 0px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid #ffab91;
  text-transform: uppercase;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.app-status-badge.inactive {
  background-color: #fbe9e7;
  color: #d84315;
  border-color: #ffab91;
}

@media (max-width: 768px) {
  .app-meta {
    flex-wrap: wrap;
    font-size: 13px;
  }
  
  .app-status-badge {
    padding: 4px 10px;
    font-size: 8px;
  }

  .app-icon{
    width: 60px;
    height: auto;
  }
  .app-name{
    font-size: 18px;
  }

  .platform-badge{
    font-size: 12px;
  }
}
</style>
